import groupBy from "lodash/groupBy";
import isEqual from "lodash/isEqual";

import {getFilterGroupValue, getFilterGroupValues, s3FilterImagePath} from "../../../misc/utils";
import {getCurrentLayout, getCurrentRoomType} from "../../appLayout";
import {
  ALL_CONTEXT_MENU,
  CONTEXT_MENU_BATHTUB_BUTTONS,
  CONTEXT_MENU_SHOWER_ALL,
  CONTEXT_MENU_SHOWER_OTHER,
  CONTEXT_MENU_SPLIT_WALL,
  CONTEXT_MENU_VANITY_BUTTONS,
  POSSIBLE_ONE_POSITION,
  VANITY_TYPES,
  LOOK_ROOM_TYPES,
  ALL_CONTEXT_MENU_KITCHEN,
  CONTEXT_MENU_KITCHEN_CENTER_ISLAND,
  CONTEXT_MENU_KITCHEN_COUNTERTOPS,
  CONTEXT_MENU_VANITY_ONLY, CONTEXT_MENU_SHOWER_ACCESSORIES, METADATA, allShowerSideOptionsGroups
} from "../core/constants";
import {getCartItemObject, getFeatureIsLocked} from "../../../misc/helpers";
import {getBundledFeatures, getDbFeatureProperty, hardCodelyRemovedClicking} from "./lookFunctions2";
import {isFeatureEnabled, isVisibleForNavigation} from "../../../misc/displayLogic";
import {allowCheckForCollection} from "../grohe/groheNavigation/groheFunctions";
import {CART_ITEM_ADDED_BY} from "../../shoppingCart/cartItemInterface";
import {getCommonVisualizerType, IS_LIXIL_SERVERS, IS_PRODUCT_JOURNEY, IS_QKB_UI} from "../../../config";
import {GROHE_CONFIG} from "../grohe/groheConfig";
import {addLayoutHistory} from "../../../actions/actionFunctions";
import store from "../../../store";
import {getExistingWizardForGroups} from "./lookMain/lookWizard/lookWizardFunctions";
import {getColorFilterValue} from "../../../misc/filtersFunctions";
import {getFeatureCropCoors} from "../../../misc/metaDataFunctions";
import {ROUTES} from "../../../routes";
import {isFeatureNotInVisualizerNow} from "../../visComponents/featuresFunctions";

const WIZARD_URL_PART = ROUTES.wizard.replace("/", ""); // "wizard"


/**
 * Checks available color options for reature
 * @param lookActiveFeature {object}
 * @param filterGroups {array}
 * @param returnAllFeatures {boolean}
 * @param fromNavItemOptions {array}
 * @param selectedFilters {array}
 * @returns  {array} array of objects
 */
export const getFeatureOptions = (lookActiveFeature, filterGroups, returnAllFeatures = false, fromNavItemOptions = null, selectedFilters = []) => {
  if (!lookActiveFeature) {
    return null
  }

  const colorFilterGroup = filterGroups.find(group => group.name === "Color");

  if (!colorFilterGroup) {
    return null
  }

  const activeFeatureValues = getFilterGroupValues(lookActiveFeature, colorFilterGroup);

  // console.log("activeFeatureValues", activeFeatureValues);

  if (!Array.isArray(activeFeatureValues) || !activeFeatureValues.length) {
    return null
  }

  const parent = lookActiveFeature.getParent();
  const activeFeatureValue = getFilterGroupValue(activeFeatureValues[0], colorFilterGroup);

  let optionFeatures = activeFeatureValue ? [{
    feature: lookActiveFeature,
    colorValue: activeFeatureValue
  }] : [];

  if (fromNavItemOptions && !selectedFilters.length) {
    // console.log("optionFeatures", optionFeatures);
    return activeFeatureValue && fromNavItemOptions.some(option => option.colorValue.id === activeFeatureValue.id)
      ? fromNavItemOptions
      : [...optionFeatures, ...fromNavItemOptions]
  }

  const layout = getCurrentLayout();
  let navItems;
  if (returnAllFeatures) {
    const layout = getCurrentLayout();
    const forSpecificLayout = lookActiveFeature.metaData["RoomLayout"] ? lookActiveFeature.metaData["RoomLayout"][0] : null;
    if (forSpecificLayout && (+(forSpecificLayout.replace("Layout", "")) !== layout.type)) {
      navItems = parent.getFeaturesForNavigationFrom({
        returnAllFeatures,
        forSpecificLayout: lookActiveFeature.metaData["RoomLayout"] ? lookActiveFeature.metaData["RoomLayout"][0] : null,
        forSpecificScene: lookActiveFeature.metaData["RoomScene"] ? lookActiveFeature.metaData["RoomScene"][0] : null
      })
    } else {
      navItems = layout.designNavigationItems({part: parent}, {}, "", lookActiveFeature, false)
    }
  } else {
    navItems = layout.designNavigationItems({part: parent}, {}, "", lookActiveFeature, false)
  }

  optionFeatures = getOptionsFromNavItemsForFeature(lookActiveFeature, navItems, filterGroups, optionFeatures);
  return optionFeatures
};

export const getOptionsFromNavItemsForFeature = (lookActiveFeature, navItems, filterGroups, optionFeatures = []) => {
  const activeFeatureCollectionName = lookActiveFeature.getCollectionName(filterGroups);
  const matchingOptionsName = lookActiveFeature.getMatchingOptionsName();
  const matchingFeatureProperty = lookActiveFeature.useMatchingFeatureReplacement || "MatchingFeature";

  for (let i = 0; i < navItems.length; i++) {
    const checkFeature = navItems[i].part || navItems[i];
    if (checkFeature.dbFeature.id === lookActiveFeature.dbFeature.id) {
      continue
    }
    if (checkFeature.getMatchingOptionsName() !== matchingOptionsName) {
      continue
    }
    // console.log("checkFeature", checkFeature);
    const filterValue = getColorFilterValue(checkFeature, filterGroups);
    if (!filterValue) {
      continue
    }
    if (lookActiveFeature.metaData[matchingFeatureProperty] && !isEqual(lookActiveFeature.metaData[matchingFeatureProperty], checkFeature.metaData[matchingFeatureProperty])) {
      continue
    }
    if (document.kvConfig.visualizerType === "bvLook") {
      if (allowCheckForCollection(checkFeature) && (checkFeature.getCollectionName(filterGroups) !== activeFeatureCollectionName)) {
        continue
      }
      if (lookActiveFeature.partId !== "vanity_sink" && (lookActiveFeature.dbFeature[getDbFeatureProperty("lixilProductSubCategory")] !== checkFeature.dbFeature[getDbFeatureProperty("lixilProductSubCategory")])) {
        continue
      }
      if (lookActiveFeature.partId === "vanity_cabinet" && lookActiveFeature.dbFeature.metaData["VanitySize"]
          && !isEqual(lookActiveFeature.metaData["VanitySize"], checkFeature.metaData["VanitySize"])) {
        continue
      }
    }
    if (optionFeatures.every(optFeature => optFeature.colorValue.id !== filterValue.id)) {
      optionFeatures.push({
        feature: checkFeature,
        colorValue: filterValue
      })
    } else if (lookActiveFeature.partId === "vanity_sink" && (document.kvConfig.visualizerType === "bvLook")) {
      const alreadyAddedOptionIndex = optionFeatures.findIndex(optFeature => optFeature.colorValue.id === filterValue.id);
      if (alreadyAddedOptionIndex > -1
        && !isEqual(optionFeatures[alreadyAddedOptionIndex].feature.metaData["MountHoles"], lookActiveFeature.metaData["MountHoles"])
        && isEqual(checkFeature.metaData["MountHoles"], lookActiveFeature.metaData["MountHoles"])) {
        optionFeatures.splice(alreadyAddedOptionIndex, 1, {
          feature: checkFeature,
          colorValue: filterValue
        })
      }
    }
  }
  return optionFeatures
}


/**
 * returns matching color feature depending on the feature passed
 * @param activeFeature {featureInterface}
 * @param notMatchingFeature {featureInterface}
 * @param filterGroups {array}
 * @returns featureFound {featureInterface}
 */
export const getMatchingColorFeature = (activeFeature, notMatchingFeature, filterGroups) => {
  if (activeFeature) { //just in case
    const colorFilterValue = getColorFilterValue(activeFeature, filterGroups);
    // console.log("colorFilterValue", colorFilterValue);
    const currentCollectionName = notMatchingFeature.getCollectionName(filterGroups);
    const currentFeatureName = activeFeature.getSplittedFeatureName();
    const parent = notMatchingFeature.getParent();
    const navItems = parent.navigationSubItems({}, "", notMatchingFeature);

    let featureFound = null;
    let featureFoundItems = navItems.filter((navItem) => {  // 2) match by color filter
      const colorValue = getColorFilterValue(navItem.part, filterGroups);
      return !!(colorValue && colorFilterValue && (
        (colorValue.id === colorFilterValue.id)
        || [colorValue,colorFilterValue].every(filterValue => filterValue.displayText && filterValue.displayText.toLowerCase().includes("chrome"))
      ));
    });
    if (featureFoundItems.length) {
      featureFound =
        featureFoundItems.find(navItem => navItem.part.getSplittedFeatureName() === currentFeatureName) // 2) match by sku
        || featureFoundItems.find(navItem => navItem.part.getCollectionName(filterGroups) === currentCollectionName) // 3) match by collection
        || featureFoundItems[0];  // 4) return at least something
    } else {
      featureFound = navItems.find(navItem => {
        return navItem.part.getSplittedFeatureName() === currentFeatureName // 2) match by sku
      });
    }
    return featureFound
  }
  return null
};

/**
 * returns same color features but different feature groups
 * @param lookActiveFeature {featureInterface}
 * @param filterGroups {array}
 * @param sameColorOnly {boolean}
 * @returns sameColorFeatures {array}
 */
export const getSameColorFeatures = (lookActiveFeature, filterGroups, sameColorOnly = true) => {
  let sameColorFeatures = [];
  let differentColorFeatures = [];
  const doNotShowStylePopupFor = ["bathtub_body", "vanity_cabinet", "vanity_middle", "shower_pan_combo", "replacement_tub", "jetted_tub"];
  const isAsBathroom = getCurrentRoomType() === LOOK_ROOM_TYPES.as;

  if (lookActiveFeature && (doNotShowStylePopupFor.includes(lookActiveFeature.partId)) && isAsBathroom) {
    return {sameColorFeatures, differentColorFeatures}
  }

  const featureGroups = getLookList(true);
  if (featureGroups) {
    const activeFilterGroupValue = getColorFilterValue(lookActiveFeature, filterGroups);
    // if (Config.isDevMode()) {
      // console.log("activeFilterGroupValue", activeFilterGroupValue);
    // }
    featureGroups.forEach(parentObject => {
      if (activeFilterGroupValue && !(parentObject.featureGroup && parentObject.featureGroup.disabled)
        && !(parentObject.featureGroup && parentObject.featureGroup.hideLayerCondition && parentObject.featureGroup.hideLayerCondition())
        && parentObject.cartFeature && (parentObject.cartFeature.partId !== lookActiveFeature.partId)) {
        const colorValue = getColorFilterValue(parentObject.cartFeature, filterGroups);
        if (colorValue && (colorValue.id !== activeFilterGroupValue.id)) {
          const sameFeatureAsActive = getMatchingColorFeature(lookActiveFeature, parentObject.cartFeature, filterGroups);
          const bathroomShowerPanExclude = isAsBathroom
            && (sameFeatureAsActive && sameFeatureAsActive.part.partId === "shower_pan_combo")
            && sameFeatureAsActive.part.getParent().getParent().layout.parts["Shower Tub Combo"]
            && sameFeatureAsActive.part.getParent().getParent().layout.parts["Shower Tub Combo"].showerTubComboIsActive;
          if (sameFeatureAsActive && !bathroomShowerPanExclude) {
            sameColorFeatures.push(sameFeatureAsActive.part);
            differentColorFeatures.push(parentObject.cartFeature);
          } else if (IS_PRODUCT_JOURNEY && !sameColorOnly) {
            differentColorFeatures.push(parentObject.cartFeature);
          }
        } else if (IS_PRODUCT_JOURNEY && !sameColorOnly) {
          differentColorFeatures.push(parentObject.cartFeature);
        }
      }
    })
  }
  // console.log("sameColorFeatures", sameColorFeatures);
  // console.log("differentColorFeatures", differentColorFeatures);
  return {sameColorFeatures, differentColorFeatures}
};

/**
 * returns same color features but different feature groups
 * @param lookActiveFeature {featureInterface}
 * @param fromArray {array}
 * @param filterGroups {array}
 * @returns displayFeatures {array}
 */
export const getDisplaySameColorGroups = (lookActiveFeature, fromArray, filterGroups) => {

  if (!lookActiveFeature || !fromArray.length || !filterGroups) {
    return []
  }

  // const activeFilterGroupValue = getColorFilterValue(lookActiveFeature, filterGroups);
  const activeCollectionFilterGroupValue = lookActiveFeature.getCollectionName(filterGroups);

  let displayFeatures = [];
  let otherGroup = {
    colName: "other",
    features: []
  }
  let currentColGroup = {
    colName: activeCollectionFilterGroupValue,
    features: []
  }
  if (activeCollectionFilterGroupValue) {
    displayFeatures.push(currentColGroup)
  }
  displayFeatures.push(otherGroup);


  fromArray.forEach(feature => {
    if (displayFeatures.some(sameColorObject => sameColorObject.features.some(addedFeature => addedFeature.partId === feature.partId))) {
      return false
    }

    const currentCollectionValue = feature.getCollectionName(filterGroups);

    if (currentCollectionValue && activeCollectionFilterGroupValue && (currentCollectionValue === activeCollectionFilterGroupValue)) {
      currentColGroup.features.push(feature)
    } else {
      otherGroup.features.push(feature)
    }
  });
  displayFeatures = displayFeatures
    .filter(sameColorObject => sameColorObject.features.length)
    .sort((a,b) => (a.colName === "other") - (b.colName === "other"));

  // console.log("displayFeatures", displayFeatures);

  return displayFeatures
};


/**
 * returns a list needed for integration
 * @param checkFeature {object}
 * @param filterGroups {array}
 * @returns {array}
 */
export const getSimilarItemsList = (checkFeature, filterGroups) => {
  if (!checkFeature) {
    return []
  }
  const featureGroups = getLookList();
  if (!featureGroups) {
    return []
  }
  let matchingFeatures = [];
  const activeFilterGroupValue = getColorFilterValue(checkFeature, filterGroups);
  const collectionName = checkFeature.getCollectionName(filterGroups);
  featureGroups.forEach(parentObject => {
    if (parentObject.partId === checkFeature.partId) {
      return
    }
    const navItems = parentObject.featureGroup.navigationSubItems({}, "", checkFeature)
    const sameColorItems = navItems.filter((navItem) => {  // 2) match by color filter
      const colorValue = getColorFilterValue(navItem.part, filterGroups);
      return colorValue && activeFilterGroupValue && (colorValue.id === activeFilterGroupValue.id)
    });
    if (sameColorItems.length) {
      const sameCollectionFeature = sameColorItems.find(navItem => {
        return navItem.part.getCollectionName(filterGroups) === collectionName
      });
      matchingFeatures.push(sameCollectionFeature ? sameCollectionFeature.part : sameColorItems[0].part);
    } else if (parentObject.cartFeature) {
      // tubs, toilets and shower pans? for now let's push all
      matchingFeatures.push(parentObject.cartFeature);
    }
  })
  return matchingFeatures
}

const setLayerPosition = (position, featureGroup) => {
  let sameFeature = featureGroup.getMatchingPositionFeature(position, featureGroup.activeFeature);
  // console.log("sameFeature", sameFeature);
  if (sameFeature && (featureGroup?.partId === "vanity_ptrap") && !isFeatureEnabled(sameFeature, "visualizer")) {
    sameFeature = null
  }
  if (sameFeature) {
    featureGroup.activeFeature = sameFeature;
  }
  featureGroup.layerPositions[position] = sameFeature || null; // if no feature found - erase previous
}

const updateMirrorAndWallsCrop = (feature) => {
  const layout = getCurrentLayout();
  const vanityParent = layout.parts["Vanity"];
  if (!vanityParent || !vanityParent.mirror || !vanityParent.relatedItems || !vanityParent.relatedItems.some(relItem => relItem.partId === feature.partId)) {
    return
  }
  vanityParent.mirror.setLayers(layout);
  const wallsParent = layout.parts["Walls"];
  if (wallsParent && wallsParent.relatedItems) {
    wallsParent.relatedItems.forEach(wallFeatureGroup => {
      if (wallFeatureGroup.hasAdditionalParts) {
        wallFeatureGroup.checkIfFeaturePartIsMatching(); // update crops after mirror change
      }
    })
  }
}

/**
 * Updates Vanity related items sides
 * @param feature {featureInterface}
 * @param oldActiveFeature {featureInterface}
 */
export const updateVanitySides = (feature, oldActiveFeature = null) => {
  const layout = getCurrentLayout();
  const currentSideMeta = oldActiveFeature ? oldActiveFeature.metaData.layerPosition : null;
  const nextSideMeta = feature.metaData.layerPosition;
  const vanityParent = layout.parts["Vanity"];
  if (!vanityParent || !vanityParent.relatedItems || !vanityParent.relatedItems.some(relItem => relItem.partId === feature.partId)
    || feature.partId === "vanity_mirror" || feature.partId === "vanity_lighting") { // vanity mirror is independent! it has Vanity Size and mirror shape meta
    return
  }

  if (feature.partId === "vanity_cabinet") {
    const nextVanityIsDouble = vanityParent.isDoubleVanity(feature);
    vanityParent.relatedItems.forEach(featureGroup => {
      if (feature.partId === featureGroup.partId || featureGroup.partId === "vanity_mirror") {
        // feature is already applied, no need to do anything
        return
      }
      if (featureGroup.layerPositions) {
        const isCountertopOrBacksplash = featureGroup.partId === "vanity_countertop" || featureGroup.partId === "vanity_backsplash";
        const canBeCSideToo = featureGroup.partId === "door_handle" || featureGroup.partId === "drawer_handle";

        Object.keys(featureGroup.layerPositions).forEach(position => {
          if (isCountertopOrBacksplash || canBeCSideToo) {
            if (position === feature.metaData.layerPosition || (position !== "C" && feature.metaData.layerPosition !== "C")) {
              setLayerPosition(position, featureGroup);
            } else {
              featureGroup.layerPositions[position] = null; // erase sibling positions
            }
          } else {
            if (position === "C" && (nextVanityIsDouble && feature.metaData.layerPosition === "C"
              || (!nextVanityIsDouble && nextSideMeta !== "C"))) {
              featureGroup.layerPositions[position] = null; // erase sibling positions
            } else if (position !== "C" && !nextVanityIsDouble && feature.metaData.layerPosition === "C") {
              featureGroup.layerPositions[position] = null; // erase sibling positions
            } else {
              setLayerPosition(position, featureGroup);
            }
          }
        })
      }
    })
    return
  }

  if (nextSideMeta === currentSideMeta) {
    return
  }
  if (!((currentSideMeta !== "C" && nextSideMeta === "C") || (nextSideMeta !== "C" && currentSideMeta === "C"))) {
    return // no need to change anything
  }

  vanityParent.relatedItems.forEach(featureGroup => {
    if (feature.partId === featureGroup.partId) {
      // feature is already applied, no need to do anything
      return
    }
    if (featureGroup.layerPositions) {
      Object.keys(featureGroup.layerPositions).forEach(position => {
        if ((position !== "C" && feature.metaData.layerPosition === "C") || (feature.metaData.layerPosition !== "C" && position === "C")) {
          if (featureGroup.getParent().vanity_type === "vanity_cabinet"
            && (featureGroup.partId === "vanity_cabinet")
            && (feature.metaData.layerPosition !== "C" && position === "C")
            && (featureGroup.layerPositions["C"] && !featureGroup.layerPositions["L"] && !featureGroup.layerPositions["R"])
            && featureGroup.layerPositions["C"].metaData["MatchingFeature"]
            && featureGroup.layerPositions["C"].metaData["MatchingFeature"].includes(METADATA.NO)
            && featureGroup.layerPositions["C"].metaData["VanityWidth"]
            && featureGroup.layerPositions["C"].metaData["VanityWidth"] === 64) {
            return; // do not erase 64 vanity if we are trying to apply L sink, it can be used with 64 vanity size
          }
          featureGroup.layerPositions[position] = null; // erase sibling positions
        } else {
          if (nextSideMeta === position && featureGroup.layerPositions[position]) {
            // feature is already applied, no need to search for it
            return
          }
          setLayerPosition(position, featureGroup);
        }
      })
    }
  })
}

export const applyFeatureToLayerPosition = (feature,
                                            applyOnlyToCurrentParentPositions = false,
                                            currentActiveFeature = null) => {
  if (!feature || isFeatureNotInVisualizerNow(feature) || !feature.metaData.layerPosition) {
    return
  }
  const parent = feature.getParent();
  if (parent.layerPositions) { // prevent clicking on disabled item if same sku is opened for enabled feature
    // if (fromUrl && Object.keys(parent.layerPositions).some(layerPosition => !parent.layerPositions[layerPosition])) {
    //   return false
    // }
    const alwaysApplyBothPositionsFor = ["vanity_cabinet", "vanity_mirror"];
    Object.keys(parent.layerPositions).forEach(position => {
      if (applyOnlyToCurrentParentPositions && !alwaysApplyBothPositionsFor.includes(feature.partId)
        && !(feature.partId === "vanity_sink" && feature.metaData?.layerPosition && (feature.metaData.layerPosition !== "C"))) {
        if (!parent.layerPositions[position]) {
          return;
        }
        if (position === feature.metaData.layerPosition) {
          parent.layerPositions[position] = feature
        } else {
          const sameFeature = parent.getMatchingPositionFeature(
            position,
            feature,
            null,
            parent.getActiveFeatureConditions(feature),
            true
          );
          parent.layerPositions[position] = sameFeature || null; // if no feature found - erase previous
        }
        return
      }
      if (position === feature.metaData.layerPosition) {
        parent.layerPositions[position] = feature
      } else if ((position !== "C" && feature.metaData.layerPosition === "C") || (feature.metaData.layerPosition !== "C" && position === "C")) {
        parent.layerPositions[position] = null; // erase sibling positions
      } else if (!allShowerSideOptionsGroups.includes(parent.partId) || parent.layerPositions[position]) { // do not turn on new positions. only change existing
        const sameFeature = parent.getMatchingPositionFeature(position, feature, null, parent.getActiveFeatureConditions(feature));
        // console.log("sameFeature", sameFeature);
        parent.layerPositions[position] = sameFeature || null; // if no feature found - erase previous
      }
    });
    if (applyOnlyToCurrentParentPositions && !Object.keys(parent.layerPositions).some(pos => parent.layerPositions[pos])) {
      //apply at least clicked position
      parent.layerPositions[feature.metaData.layerPosition] = feature;
    }
  } else if (parent.oneLayerPosition && applyOnlyToCurrentParentPositions) {
    if (!currentActiveFeature || !currentActiveFeature.metaData.layerPosition
      || (currentActiveFeature.metaData.layerPosition === feature.metaData.layerPosition)) {
      return;
    }
    const sameFeature = parent.getMatchingPositionFeature(
      currentActiveFeature.metaData.layerPosition,
      feature,
      null,
      parent.getActiveFeatureConditions(feature),
      true
    );
    if (sameFeature) {
      parent.activeFeature = sameFeature; // set not clicked feature, but current side feature
    }
  }
}

const removeAllFeatureGroupPositionsFirstTime = (featureClicked, parent) => {
  if (!featureClicked
    || isFeatureNotInVisualizerNow(featureClicked)
    || !parent
    || !parent.layerPositions
    || !parent.disabled
    || !featureClicked.metaData.layerPosition) {
    return
  }
  const {activeQuoteIndex} = store.getState().quotesState;
  if (parent.firstClick[activeQuoteIndex]) {
    return;
  }
  Object.keys(parent.layerPositions).forEach((position) => {
    if (position !== featureClicked.metaData.layerPosition) {
      parent.layerPositions[position] = null;
    }
  })
}

/**
 * Simple navigation feature click
 * @param feature {object}
 * @param updateLocalStorage {boolean}
 * @param forceClick {boolean}
 * @param updateVanityPositions {boolean}
 * @param fromQuotingTool {boolean}
 // * @param fromUrl {boolean}
 * @returns {boolean}
 */
export const navFeatureCLick = (feature,
                                updateLocalStorage = true,
                                forceClick = false,
                                updateVanityPositions = true,
                                fromQuotingTool = false) => {
  const parent = feature.getParent();
  const featureIsLocked = getFeatureIsLocked(feature);
  if (featureIsLocked && !forceClick) {
    feature.handleClick(forceClick); // update active locked feature or active not in visualizer feature
    return false
  }

  removeAllFeatureGroupPositionsFirstTime(feature, parent);

  const currentActiveFeature = parent.activeFeature;
  const asBathroom = getCurrentRoomType() === LOOK_ROOM_TYPES.as;
  if (asBathroom) {
    if (feature.partId === "vanity_sink" && (document.kvConfig.visualizerType === "bvLook")) {
      feature.handleClick(forceClick, true);
    } else if (feature.partId === "vanity_cabinet" && (document.kvConfig.visualizerType === "bvLook") && !updateVanityPositions) {
      feature.handleClick(forceClick, false); // do not click again on the sink, we came from the sink click
    } else {
      feature.handleClick(forceClick); // first set custom types (for vanity)
    }
  }

  if (parent.disabled && !isFeatureNotInVisualizerNow(feature)) {
    parent.disabled = false;
    parent.disabledClick();
  }

  if (feature.partId === "vanity_cabinet" && (document.kvConfig.visualizerType === "bvLook") && !updateVanityPositions) {
    feature.handleClick(forceClick, false); // do not click again on the sink, we came from the sink click
  } else {
    feature.handleClick(forceClick); // update active feature or active not in visualizer feature
  }

  applyFeatureToLayerPosition(feature, fromQuotingTool, currentActiveFeature);
  // applyBathroomLogicAfterFeaturePositionClick(feature); this breaks logic with C to C click, ot L to C

  if (updateLocalStorage && !IS_QKB_UI) { // we don't have restore from history on QKB UI, only look or product journey
    const layout = getCurrentLayout();
    store.dispatch(addLayoutHistory(layout.getActiveFeaturesAsObject(false, false, true)))
  }
  if (parent.layerPositions && feature.metaData.layerPosition && updateVanityPositions && !isFeatureNotInVisualizerNow(feature)) {
    updateVanitySides(feature, currentActiveFeature);
    updateMirrorAndWallsCrop(feature);
  }
}

/**
 * For delete buttons
 * @param feature {object}
 * @param featureParent {object}
 * @param checkDisabledOnly {boolean}
 * @returns {boolean}
 */
export const checkIfFeatureDisabled = (feature, featureParent, checkDisabledOnly = false) => {
  if (!featureParent) {
    featureParent = feature.getParent();
  }
  const isDisabled = featureParent.layerPositions
    ? Object.keys(featureParent.layerPositions).every(pos => !featureParent.layerPositions[pos])
    : featureParent.disabled;
  return checkDisabledOnly ? isDisabled : isDisabled && featureParent.canBeDisabled
}

/**
 * Returns active features list for
 * @param withLayerPositions {boolean} return all positions features
 * @param withDisabled {boolean} return feature positions even disabled
 * @param showAllGroups {boolean} returns all layout feature groups
 * @param showAllQtCategories {boolean} returns quotingTool featureGroups
 * @param displayInMenu {boolean} whether to display in look menu
 * @returns {array} array of objects
 */
export const getLookList = (withLayerPositions = false,
                            withDisabled = false,
                            showAllGroups = false,
                            showAllQtCategories = false,
                            displayInMenu = false) => {
  const layout = getCurrentLayout();

  let featureGroups = [];

  if (showAllGroups) {
    layout.getFeatures().forEach(parent => {
      parent.relatedItems.forEach(featureGroup => {
        if (!featureGroup.activeFeature) {
          featureGroup.setDefault(layout, true);
        }
        if (!featureGroup.activeFeature) {
          return
        }
        featureGroups.push({
          selectionGroup: parent.partName,
          partId: featureGroup.partId,
          quantity: 0,
          cartFeature: featureGroup.activeFeature,
          featureGroup,
        })
      })
    });
    return featureGroups
  }

  if ((!IS_LIXIL_SERVERS || showAllQtCategories) && layout.qtCategories) {
    layout.qtCategories.forEach((qtCategory) => {
      qtCategory.defaultSubParts.forEach(subPart => {
        if (document.kvConfig.visualizerType === "kvScene") {
          if ((subPart.part.partId === "center_island_edge" && layout.type === 3)
            || (subPart.part.partId === "crown_molding" && (layout.type === 2 || layout.type === 3 || layout.type === 5))) {
            return
          }
        }
        if (!featureGroups.some(parentObject => parentObject.partId === subPart.part.partId)) {
          featureGroups.push({
            selectionGroup: subPart.part.getParent().partName,
            partId: subPart.part.partId,
            quantity: 0,
            cartFeature: subPart.part.activeFeature, // it can be null here! it's ok since we need to show featureGroups from another layouts (for shop)
            featureGroup: subPart.part
          })
        }
      })
    })
    return featureGroups
  }

  let featureGroupsObjects = layout.getActiveFeatures(false, withLayerPositions, withDisabled);
  // console.log("parentGroups before wizard clean", featureGroupsObjects);

  if (displayInMenu) {
    const {wizardList} = store.getState().wizardState;
    if (Array.isArray(wizardList) && wizardList.length) {
      wizardList.forEach(wizardItem => {
        if (wizardItem.hideItems && Array.isArray(wizardItem.wizardGroups) && wizardItem.wizardGroups.length) {
          featureGroupsObjects = featureGroupsObjects.filter(parentObject => {
            return wizardItem.wizardGroups.every(wizardGroup => {
              return (parentObject.featureGroup.dbName || parentObject.featureGroup.partName) !== wizardGroup.groupName
            })
          })
        }
      })
    }
  }

  const parentGroups = groupBy(featureGroupsObjects, 'selectionGroup');
  // console.log("parentGroups", parentGroups);

  if (!Object.keys(parentGroups).length) {
    return null
  }

  const visType = getCommonVisualizerType();
  const sortByParents = visType === "bathroom"
    ? ["Vanity", "Shower", "Shower Tub Combo", "Shower Accessories", "Bathtub", "Toilet", "Floor", "Walls", "Window"]
    : visType === "kitchen"
      ? ["Countertop", "CenterIsland", "Cabinet", "Appliances", "Walls", "Floor"]
      : Object.keys(parentGroups);

  sortByParents.forEach(parentKey => {
    featureGroups = [...featureGroups, ...(parentGroups[parentKey] || [])]
  });

  if (getCurrentRoomType(layout) === LOOK_ROOM_TYPES.as) {
    const vanityParent = layout.parts["Vanity"];
    featureGroups = featureGroups.filter(parentObject => {
      if (parentObject.partId === "vanity_ws_towel_bar" && vanityParent.vanity_type !== VANITY_TYPES.vanity_washstand) {
        return false
      } else if ((parentObject.partId === "vanity_middle" || parentObject.partId === "vanity_legs") && vanityParent.vanity_type !== VANITY_TYPES.vanity_cabinet) {
        return false
      }
      return !(vanityParent && Object.keys(VANITY_TYPES).includes(parentObject.partId) && vanityParent.vanity_type !== parentObject.partId);
    })
  }
  // console.log("featureGroups", featureGroups);

  // simple hardcoded sort
  return featureGroups.filter(parentObject => parentObject.cartFeature)
}

/**
 * Returns look navigation list height
 * @param lmFeatureParent {object}
 * @param lookViewType {number}
 * @param lookParentKeys {array}
 * @returns {number}
 */
export const getLookListHeight = (lmFeatureParent, lookViewType, lookParentKeys) => {
  const opened = lookParentKeys.includes(lmFeatureParent.partId);
  // const featuresLength = parentGroups[parentKey].length;
  let featuresLength = 1;
  if (lmFeatureParent.layerPositions) {
    if (POSSIBLE_ONE_POSITION.includes(lmFeatureParent.partId)) {
      featuresLength = 0;
      Object.keys(lmFeatureParent.layerPositions).forEach(position => {
        if (lmFeatureParent.getMatchingPositionFeature(position)) {
          featuresLength += 1;
        }
      });
    } else {
      featuresLength = Object.keys(lmFeatureParent.layerPositions).length
    }
  }
  let listHeight = 0;
  const styleNotificationIsVisible = getStyleAlertIsVisibleForGroup(lmFeatureParent);
  if (opened) {
    switch (lookViewType) {
      case 1:
      default:
        listHeight = 104 * featuresLength; // feature height 88 + feature margin 16
        break;
      case 2:
        listHeight = (172 + 22) * Math.ceil(featuresLength / 2); // feature height 156 + feature margin 16 + featureName 22
        break;
      case 3:
        listHeight = (280 + 22 + 16) * featuresLength; // feature height 280 + feature margin 16 + featureName 22
        break;
    }
    if (styleNotificationIsVisible) {
      listHeight += 96 // 80 + 8 + 8 margins
    }
  }
  return listHeight
}

const disallowedSkus = ["athtub"];

/**
 * @param feature {featureInterface}
 * @param listObject {{featureGroup: featureGroupInterface}}
 * @returns {boolean}
 */
export const checkIfFeatureCanBeAddedToTheCart = (feature, listObject) => {
  let allowed = (document.kvConfig.visualizerOnly || isVisibleForNavigation(feature, true))
    && !disallowedSkus.some(sku => feature.dbFeature.sharedFeatureName.includes(sku))
  if (allowed && listObject?.featureGroup && listObject.featureGroup.hideLayerCondition?.()) {
    allowed = false
  }
  return allowed
}

/**
 * Creates cart items list depending on quotingTool features
 * @param qtActiveCategory {string} current active quote category name
 * @param loadByTheDefault {object} loadByTheDefault object from localstorage
 * @returns {array} array of cart items
 */
export const createCartList = (qtActiveCategory, loadByTheDefault = null) => {
  const featureGroups = getLookList(true);
  let cartItems = [];
  if (featureGroups && featureGroups.length) {
    featureGroups.forEach(featureGroup => {
      if ((getCurrentRoomType() === LOOK_ROOM_TYPES.as) && featureGroup.featureGroup.hideLayerCondition && featureGroup.featureGroup.hideLayerCondition()) {
        return
      }
      const existingCartItem = cartItems.find(cItem => {
        if (!featureGroup.cartFeature) {
          return null
        }
        return (cItem.partId === featureGroup.cartFeature.partId)
          && cItem.cartFeature.dbFeature.sharedFeatureName && featureGroup.cartFeature.dbFeature.sharedFeatureName
          && (cItem.cartFeature.dbFeature.sharedFeatureName === featureGroup.cartFeature.dbFeature.sharedFeatureName)
      });
      let quantity = 1;
      let loadByTheDefaultCItem = null;
      if (loadByTheDefault && loadByTheDefault.cartState && Array.isArray(loadByTheDefault.cartState.cartItems)){
        loadByTheDefaultCItem = loadByTheDefault.cartState.cartItems.find(cItem => {
          const foundFeature = featureGroup.featureGroup.getFeatureById(cItem.cartFeature.dbFeatureId, true)
          if (foundFeature) {
            return foundFeature.dbFeature.sharedFeatureName && featureGroup.cartFeature.dbFeature.sharedFeatureName
              && (foundFeature.dbFeature.sharedFeatureName === featureGroup.cartFeature.dbFeature.sharedFeatureName)
          }
          return cItem.cartFeature.dbFeatureId === featureGroup.cartFeature.dbFeature.id
        })
        if (loadByTheDefaultCItem) {
          quantity = loadByTheDefaultCItem.quantity;
        } else {
          quantity = 0
        }
      }

      if (existingCartItem && quantity) {
        if (!loadByTheDefaultCItem) {
          existingCartItem.quantity += quantity;
        }
      } else if (featureGroup.cartFeature && checkIfFeatureCanBeAddedToTheCart(featureGroup.cartFeature, featureGroup) && quantity) {
        const newCartItem = getCartItemObject(featureGroup.cartFeature, quantity, qtActiveCategory);
        newCartItem.addedBy = CART_ITEM_ADDED_BY.auto;
        cartItems.push(newCartItem);
        const relatedFeatures = getBundledFeatures(featureGroup.cartFeature);
        relatedFeatures.forEach((relatedFeature) => {
          let relatedItemQuantity = 1;
          if (loadByTheDefault && loadByTheDefault.cartState && Array.isArray(loadByTheDefault.cartState.cartItems)) {
            const alreadyAddedRelatedFeature = loadByTheDefault.cartState.cartItems.find(cartItem => {
              return cartItem.cartFeature.dbFeatureId === relatedFeature.dbFeature.id
            });
            if (alreadyAddedRelatedFeature) {
              relatedItemQuantity = alreadyAddedRelatedFeature.quantity
            }
          }
          const cartItem = getCartItemObject(relatedFeature, relatedItemQuantity, qtActiveCategory);
          cartItem.relatedProductParent = featureGroup.cartFeature;
          cartItem.addedBy = CART_ITEM_ADDED_BY.auto;
          cartItems.push(cartItem);
        })
      }
    })
  }
  console.log("cartItems created", cartItems);
  return cartItems
}

/**
 * Returns layer center
 * @param coords {object} metadata object // {min_x: 0.2109375, min_y: 1.3685185185185185, max_x: 1.9994791666666667, max_y: 2}
 * @param canvasElement {$ElementType} canvas
 * @param isMobile {boolean} on mobile we have different menu position
 * @returns {object}
 */
export const getLayerCenter = (coords, canvasElement, isMobile = false) => {
  if (!coords) {
    return null
  }
  let {clientWidth, clientHeight} = canvasElement;
  const COORDS_MAX = 1;
  // const openedMenuWidth = 712;
  // console.log("clientWidth", clientWidth);
  // console.log("clientWidth - openedMenuWidth", openedMenuWidth);
  // const threeQuater = clientWidth - (clientWidth / 4);
  // const featureViewWidth = (clientWidth - openedMenuWidth) / 2;
  let centerXPercentage = ((coords.min_x + ((coords.max_x - coords.min_x) / 2)) * 100) / COORDS_MAX;
  const centerYPercentage = ((coords.min_y + ((coords.max_y - coords.min_y) / 2)) * 100) / COORDS_MAX; // 1.5 ⋅ 100 : 2 = 75%
  // console.log("centerXPercentage", centerXPercentage);
  // let scrollPercentage = 0;
  let x = 0;
  // if (isMobile) {
  //
  //   const menuWidth = 320;
  //   const shiftX = clientWidth - (clientWidth * centerXPercentage / 100);
  //   const containerScrolled = shiftX < menuWidth;
  //
  //   const startZeroPosition = IS_PRODUCT_JOURNEY ? 15 : 13;
  //
  //   scrollPercentage = centerXPercentage < startZeroPosition
  //     ? 0
  //     : centerXPercentage > 54
  //       ? centerXPercentage - ((100 - centerXPercentage) / 3) // 80 + 5 = 85
  //       // ? centerXPercentage // 80 + 5 = 85
  //       : centerXPercentage - ((35 - centerXPercentage) - ((centerXPercentage / 100) * (35 - centerXPercentage))) // 1) calculate percent of scroll from 75 2) 61 - 12%;
  //   if (containerScrolled && (centerXPercentage > 50) && (centerXPercentage < 60)) {
  //     scrollPercentage = centerXPercentage - ((100 - centerXPercentage) / 5)
  //   }
  //   x = (clientWidth * scrollPercentage) / 100;
  // } else {
  const zoomPercentage = 75;
  if (centerXPercentage < zoomPercentage) {

    const openedMenuWidth = IS_PRODUCT_JOURNEY ? 412 : 360;
    // const featureViewWidth = IS_PRODUCT_JOURNEY ? clientWidth - openedMenuWidth : (clientWidth - openedMenuWidth - 64); // 64 is sidebar
    const featureMinX = (clientWidth * (coords.min_x * 100 / COORDS_MAX)) / 100;
    const featureMaxX = (clientWidth * (coords.max_x * 100 / COORDS_MAX)) / 100;
    const featureCenter = featureMinX + (featureMaxX - featureMinX) / 2;
    // console.log("clientWidth", clientWidth);
    // console.log("featureViewWidth", featureViewWidth);
    // console.log("centerXPercentage", centerXPercentage);
    // console.log("centerXPercentage", centerXPercentage);
    // console.log("featureMinX", featureMinX);
    // console.log("featureMaxX", featureMaxX);
    const gPointPercent = 40; // don't ask me why, just because it is magic number
    const shiftX = clientWidth - (clientWidth * centerXPercentage / 100);
    if (IS_PRODUCT_JOURNEY && isMobile && (shiftX > GROHE_CONFIG.sidebarWidth.mobile)) {
      x = featureCenter - (clientWidth * (gPointPercent - centerXPercentage)) / 100;
    } else {
      x = featureCenter - (clientWidth * (gPointPercent - centerXPercentage)) / 100 - (openedMenuWidth / 2);
    }
  } else {
    x = clientWidth;
  }
  // }
  // console.log("scrollPercentage", scrollPercentage);

  const y = (clientHeight * centerYPercentage) / 100; // 1920 ⋅ 75 : 100

  // console.log("getLayerCenter", {x, y});
  // console.log("getLayerCenter", {x, y, isMobile, featureX: centerXPercentage, clientWidth});
  return {x, y, isMobile, featureX: centerXPercentage, clientWidth}
}

/**
 * Returns layer center
 * @param coords {object} metadata object // {min_x: 0.2109375, min_y: 1.3685185185185185, max_x: 1.9994791666666667, max_y: 2}
 * @param canvasElement {$ElementType} canvas
 * @returns {object}
 */
export const getCoordsCenter = (coords, canvasElement) => {
  let {clientWidth, clientHeight} = canvasElement;
  const COORDS_MAX = 1;
  let centerXPercentage = ((coords.min_x + ((coords.max_x - coords.min_x) / 2)) * 100) / COORDS_MAX;
  const centerYPercentage = ((coords.min_y + ((coords.max_y - coords.min_y) / 2)) * 100) / COORDS_MAX; // 1.5 ⋅ 100 : 2 = 75%

  const x = (clientWidth * centerXPercentage) / 100;
  const y = (clientHeight * centerYPercentage) / 100; // 1920 ⋅ 75 : 100

  // console.log("getLayerCenter", {x, y});
  return {x, y}
}

/**
 * Returns layer center
 * @returns {object}
 */
export const getCropCoordsCenter = (feature) => {
  if (feature.metaData["CropCoords"]) {
    const parsedCoords = getFeatureCropCoors(feature);
    // const {clientWidth, clientHeight} = canvasElement;
    const clientWidth = 1920;
    const clientHeight = 1080;

    const changed =  {
      min_x: parsedCoords[0] / clientWidth,
      min_y: parsedCoords[1] / clientHeight,
      max_x: parsedCoords[2] / clientWidth,
      max_y: parsedCoords[3] / clientHeight,
    }
    // if (feature.partId) {
    //   console.log("original", feature.metaData["Coords"]);
    //   console.log("changed", changed);
    // }
    return changed
  }
  return feature.metaData["Coords"]
}

/**
 * Returns bool
 * @param lookFeature {object} feature
 * @param fromStyleAlertIcon {boolean}
 * @returns {array} not matching features
 */
export const getStyleAlertNotMatchingFeatures = (lookFeature, fromStyleAlertIcon = false) => {
  let notMatchingFeatures = [];
  if (lookFeature) {
    const featureGroup = lookFeature.getParent();

    if (fromStyleAlertIcon && !featureGroup.confirmedChange) {
      return notMatchingFeatures
    }

    const currentFeatureName = lookFeature.getSplittedFeatureName();
    // console.log("currentFeatureName", currentFeatureName);
    const wallsPartIds = ["left_wall", "front_wall", "right_wall"];
    if (wallsPartIds.includes(lookFeature.partId)) {
      const layout = getCurrentLayout();
      wallsPartIds.forEach(wallPartId => {
        const wallGroup = layout.getFeatureGroupByPartId(wallPartId);
        if (wallGroup && wallGroup.activeFeature && (wallGroup.activeFeature.getSplittedFeatureName() !== currentFeatureName)) {
          // console.log("wallGroup.activeFeature.getSplittedFeatureName()", wallGroup.activeFeature.getSplittedFeatureName());

          notMatchingFeatures.push(wallGroup.activeFeature);
        }
      })
    } else if (featureGroup.layerPositions && lookFeature.metaData.layerPosition) {
      Object.keys(featureGroup.layerPositions).forEach(position => {
        const feature = featureGroup.layerPositions[position];
        if (feature && (feature.dbFeature.id !== lookFeature.dbFeature.id)
          && (feature.getSplittedFeatureName() !== currentFeatureName)) {
          notMatchingFeatures.push(feature)
        }
      })
    }
  }
  return notMatchingFeatures
}

/**
 * Returns bool
 * @param featureGroup {object} featureGroup
 * @returns {boolean}
 */
export const getStyleAlertIsVisibleForGroup = (featureGroup) => {
  let alertIsVisible = false;
  if (featureGroup.layerPositions) {
    let names = [];
    Object.keys(featureGroup.layerPositions).forEach(position => {
      const feature = featureGroup.layerPositions[position];
      if (feature) {
        const featureName = feature.getSplittedFeatureName();
        names.push(featureName)
      }
    });
    alertIsVisible = Object.keys(featureGroup.layerPositions).some(position => {
      const feature = featureGroup.layerPositions[position];
      if (feature) {
        const featureName = feature.getSplittedFeatureName();
        return names.some(name => name !== featureName)
      }
      return false
    })
  }
  return alertIsVisible
}

/**
 * Returns array of not matched features partIds
 * @returns {array}
 */
export const getAllNotMatchingPartIds = () => {
  const layout = getCurrentLayout();
  const allFeatures = layout.getActiveFeatures(false);
  return allFeatures
    .filter(feature => getStyleAlertNotMatchingFeatures(feature.cartFeature).length)
    .map(feature => feature.partId);
}

/**
 * zooms canvas to default position
 * @param imageCanvas {object}
 * @param setCanvasScale {function}
 */
export const zoomCanvasOut = (imageCanvas, setCanvasScale) => {
  if (imageCanvas && imageCanvas.current && imageCanvas.current.pinchZoom) {
    imageCanvas.current.pinchZoom.zoomToCenter(null, 1);
    // removed as we don't see crown molding on unzoom, decided not to unzoom to floor
    // const scrollCheck = document.body.scrollHeight - document.body.clientHeight;
    // if (!scrollCheck || (scrollCheck > (document.documentElement.scrollTop + 1))) {
    //   $("html, body").animate({scrollTop: document.body.scrollHeight}, 1000);
    // }
    setCanvasScale(1);
  }
}

/**
 * creates all available rooms and room scenes
 * @param returnAllLayouts {boolean}
 * @returns objects {array}
 */
export const getRoomLayouts = (returnAllLayouts = false) => {
  const newLooks = [];
  const layout = getCurrentLayout();
  const layoutNames = Object.keys(layout.layoutNames).filter(key => key !== "All");
  const parents = layout.getFeatures();
  const isAsBathroom = getCurrentRoomType() === LOOK_ROOM_TYPES.as;
  parents.forEach(parent => {
    parent.relatedItems.forEach(relItem => {
      layoutNames.forEach(layoutName => {
        const features = relItem.featuresList[layoutName];
        for (let i = 0; i < features.length; i++) {
          const feature = features[i];
          const roomLayout = feature.dbFeature.metaData["RoomLayout"];
          const roomScene = feature.dbFeature.metaData["RoomScene"];
          if (document.kvConfig.toolVersion === 4) {
            if (feature.dbFeature.s3Bindings && Array.isArray(roomLayout) && !newLooks.some(look => look.lookLayout === layoutName)) {
              newLooks.push({
                lookLayout: layoutName,
                lookScene: "1",
              })
            }
          } else if (feature.dbFeature.s3Bindings && Array.isArray(roomLayout) && Array.isArray(roomScene) && roomLayout.length && roomScene.length) {
            if (!newLooks.some(look => (look.lookLayout === roomLayout[0]) && (look.lookScene === roomScene[0]))
              && (!isAsBathroom || (roomScene[0] === "1"))) {
              newLooks.push({
                lookLayout: roomLayout[0],
                lookScene: roomScene[0],
              })
            }
          }
        }
      })
    })
  });
  console.log("newLooks", newLooks);
  if (returnAllLayouts || (document.kvConfig.toolVersion === 4) || (
    document.kvConfig.userId === 140000
    || document.kvConfig.userId === 140001
    || window.location.href.includes("quote_bathroom_2022")
    || window.location.href.includes("qc_main_bathroom_set_2022"))) {
    return newLooks
  }
  const currentName = layout.getCurrentLayoutName();
  // if (getCurrentRoomType() === LOOK_ROOM_TYPES.as) {
  //   return newLooks
  // }
  return newLooks.filter(look => look.lookLayout === currentName)
}

/**
 * parses passed URL, and returns look ID, look category and sku
 * for the wizard urls (/look-0/wizard/190) it returns wizardIdFromUrl instead of the category/sku,
 * because the last part is the wizard item id and should never be treated as a feature sku
 * @param checkURL {string}
 * @returns parsedUrl {object}
 */
export const getParsedLookUrl = (checkURL = window.location.href) => {
  const regexForRoomPreset = /\/look(.*?)$/;
  let lookIdFromUrl = checkURL.includes("/look") ? checkURL.match(regexForRoomPreset)[1] : null;

  if (!lookIdFromUrl) {
    return {}
  }

  let featureGroupFromUrl = "";
  let skuFromUrl = "";
  let wizardIdFromUrl = "";

  let splittedLookPath = lookIdFromUrl.split("/");
  if (lookIdFromUrl && splittedLookPath.length) {
    lookIdFromUrl = +splittedLookPath[0].replace("-", "");
    if (splittedLookPath[1] === WIZARD_URL_PART) {
      wizardIdFromUrl = splittedLookPath[2] || "";
    } else {
      featureGroupFromUrl = splittedLookPath[2] ? splittedLookPath[1] : null;
      skuFromUrl = splittedLookPath[2] || splittedLookPath[1];
    }
  }
  // console.log("{lookIdFromUrl, featureGroupFromUrl, skuFromUrl}", {lookIdFromUrl, featureGroupFromUrl, skuFromUrl});

  return {lookIdFromUrl, featureGroupFromUrl, skuFromUrl, wizardIdFromUrl}
}

/**
 * compares currect and common coords - gives max & min values
 * @param currentCoords {object}
 * @param commonCoords {object}
 * @returns {object}
 */
export const compareCoords = (currentCoords, commonCoords) => {
  if (currentCoords) {
    ["min_x","min_y",].forEach(coordProp => {
      if (!commonCoords[coordProp] || (commonCoords[coordProp] > currentCoords[coordProp])) {
        commonCoords[coordProp] = currentCoords[coordProp];
      }
    });
    ["max_x", "max_y"].forEach(coordProp => {
      if (!commonCoords[coordProp] || (commonCoords[coordProp] < currentCoords[coordProp])) {
        commonCoords[coordProp] = currentCoords[coordProp];
      }
    });
  }
  return commonCoords
}

/**
 * compares currect and common coords - gives max & min values
 * @param feature {featureInterface}
 * @param isWizard {boolean}
 * @returns {object}
 */
export const getFeatureCoords = (feature, isWizard = false) => {
  if (document.kvConfig.visualizerType === "kvScene"
    && feature.metaData["RoomLayout"] && feature.metaData["RoomLayout"].includes('Layout1')
    && feature.metaData["RoomScene"] && feature.metaData["RoomScene"].includes('1')) {
    if ((feature.partId === "top_cabinet" || feature.partId === "bottom_cabinet")) {
      return feature.metaData["Coords"]
        ? Object.assign({}, feature.metaData["Coords"], {max_x: 0.2}) // do not zoom to right part of it
        : {min_x: 0, min_y: 0, max_x: 0.2, max_y: 0.38}
    } else if (feature.partId === "crown_molding") {
      return isWizard
        ? {min_x: 0.5, min_y: 0, max_x: 0.7, max_y: 0.1}
        : {min_x: 0.4, min_y: 0, max_x: 0.6, max_y: 0.1} // do not zoom to left part of it
    }

  }
  if (document.kvConfig.visualizerType === "bvLook" && feature.metaData["Coords"]) {

    if (feature.partId === "shower_wall") {
      if (feature.metaData["RoomLayout"] && feature.metaData["RoomLayout"].includes('Layout18')) {
        return Object.assign({}, feature.metaData["Coords"], {max_x: feature.metaData["Coords"].max_x / 1.8})
      }
    } else if (feature.getParent()?.getParent()?.partName === "Vanity") {
      if (feature.metaData["RoomLayout"] && feature.metaData["RoomLayout"].includes('Layout19')) {
        return Object.assign({}, feature.metaData["Coords"], {
          max_y: feature.metaData["Coords"].max_y / 0.4,
          max_x: feature.metaData["Coords"].max_x / 1.9
        })
      }
    }
  }
  return feature.metaData["Coords"]
}

/**
 * parses passed URL, and returns look ID, look category and sku
 * @param featureGroup {object}
 * @param clickedFeature {object}
 * @param canvasElement {$ElementType} canvas
 * @param layerPosition {string}
 * @returns parsedUrl {object}
 */
export const getCommonCoords = (featureGroup, clickedFeature = null, canvasElement = null, layerPosition = "") => {

  const layout = getCurrentLayout();
  let zoomFeatureGroup;
  switch (featureGroup.partId) {
    case "edge_profile":
      zoomFeatureGroup = layout.getFeatureGroupByPartId("countertop") || featureGroup;
      break;
    case "center_island_edge":
      zoomFeatureGroup = layout.getFeatureGroupByPartId("center_island_countertop") || featureGroup;
      break;
    default:
      zoomFeatureGroup = featureGroup
      break;
  }

  let commonCoords = clickedFeature ? clickedFeature.metaData.Coords || {} : {};
  if (!clickedFeature && layerPosition) {
    clickedFeature = zoomFeatureGroup.getMatchingPositionFeature(layerPosition);
  }

  const navItems = layout.designNavigationItems({part: zoomFeatureGroup}, {}, "", clickedFeature, true);

  for (let i = 0; i < navItems.length; i++) {
    const currentFeature = navItems[i].part;
    let currentCoords = getCropCoordsCenter(currentFeature, canvasElement);
    commonCoords = compareCoords(currentCoords, commonCoords);
  }
  if ((getCurrentRoomType() === LOOK_ROOM_TYPES.as) && ["front_wall", "right_wall"].some(partId => zoomFeatureGroup.partId === partId)) {
    commonCoords.min_x = 0.8 // because of the reflection in mirror, it sets min_x to 0.1, so the menu is not scrolling on open
  }
  return commonCoords
}

/**
 * toggles array val
 * @param array {array}
 * @param value {any}
 * @returns array {array}
 */
export const toggleArrayValue = (array, value) => {
  let newArray = [...array];
  let index = newArray.indexOf(value);
  (index >= 0) ? newArray.splice(index, 1) : newArray.push(value);
  return newArray;
};

/**
 * Checks if it is needed to show a context menu
 * @param partId {string}
 * @param layerPosition {string}
 * @param fabricatorData {object}
 * @returns object
 */
export const checkForContextMenuCommon = (partId, layerPosition, fabricatorData) => {
  const returnObject = {
    allButtons: [], // {partId: "", translateId: "", isWizard: true, wizardId: sting|number, hasSubMenu: false}
    showButtons: []  // {partId: "", translateId: "", isWizard: true, wizardId: sting|number, hasSubMenu: false}
  }
  if (!partId) {
    return returnObject
  }
  const isBathroom = getCommonVisualizerType() === "bathroom";
  if (isBathroom && (fabricatorData && fabricatorData.isEncore)) {
    return returnObject
  }
  const allContextMenus = isBathroom ? ALL_CONTEXT_MENU : ALL_CONTEXT_MENU_KITCHEN;
  if (!allContextMenus.includes(partId)) {
    return returnObject
  }
  // if (imageCanvas.current && imageCanvas.current.setHoveredLayer) {
  //   imageCanvas.current.renderGreenLayerByZindex(hoveredLayer.zIndex);

  let whereToCheck = isBathroom
    ? [CONTEXT_MENU_VANITY_BUTTONS, CONTEXT_MENU_BATHTUB_BUTTONS, CONTEXT_MENU_SPLIT_WALL, CONTEXT_MENU_SHOWER_ALL,
      CONTEXT_MENU_SHOWER_OTHER]
    : [CONTEXT_MENU_KITCHEN_CENTER_ISLAND, CONTEXT_MENU_KITCHEN_COUNTERTOPS];

  if (isBathroom && IS_QKB_UI) {
    whereToCheck.push(CONTEXT_MENU_SHOWER_ACCESSORIES);
  }

  let checkArray = whereToCheck.find(contextMenuArray => contextMenuArray.includes(partId)) || [];

  if (!checkArray.length) {
    return returnObject
  }

  const layout = getCurrentLayout();
  checkArray.forEach(checkPartId => {
    if (checkPartId === "vanity_legs" && layout.parts["Vanity"] && layout.parts["Vanity"].vanity_type !== VANITY_TYPES.vanity_cabinet) {
      return
    } else if (document.kvConfig.visualizerType === "kvScene" && checkPartId === "center_island_edge" && layout.type === 3) {
      return
    }
    if (layout.disabledClickablePartIds.includes(checkPartId) || hardCodelyRemovedClicking(checkPartId, layout)) {
      return;
    }
    const featureGroup = layout.getFeatureGroupByPartId(checkPartId);

    if (!isBathroom) {
      if (featureGroup && featureGroup.features.length > 0) {
        returnObject.allButtons.push({
          partId: featureGroup.partId,
          translateId: featureGroup.translateId,
        });
      }
      return;
    }

    const forFeature = featureGroup && layerPosition && featureGroup.layerPositions && featureGroup.layerPositions[layerPosition]
      ? featureGroup.layerPositions[layerPosition]
      : null;
    const withQuotingToolFeatures = layout.partIdExistInQtCategory(checkPartId);
    if (featureGroup && layout.hasNavItemsLength({part: featureGroup}, {}, "", forFeature, withQuotingToolFeatures)
      && ((featureGroup.partId !== "vanity_countertop") || featureGroup.activeFeature)) {
      returnObject.allButtons.push({
        partId: featureGroup.partId,
        translateId: featureGroup.translateId,
      });
    }
  });

  if (!returnObject.allButtons.length) {
    return returnObject
  }

  // wizard item check
  const {wizardState, bathroomVisualizerState, fabricatorState} = store.getState();
  const {wizardList, wizardIsActive} = wizardState;
  const {activePreset} = bathroomVisualizerState;

  returnObject.showButtons = returnObject.allButtons.sort((a) => partId === a.partId ? -1 : 1);

  const activeVanityType = layout.parts["Vanity"] && layout.parts["Vanity"].vanity_type ? layout.parts["Vanity"].vanity_type : VANITY_TYPES.vanity_cabinet;
  const isVanity = isBathroom && CONTEXT_MENU_VANITY_BUTTONS.includes(partId);
  const isShower = isBathroom && (CONTEXT_MENU_SHOWER_ALL.includes(partId) || CONTEXT_MENU_SHOWER_OTHER.includes(partId));
  const isCenterIsland = !isBathroom && CONTEXT_MENU_KITCHEN_CENTER_ISLAND.includes(partId);
  const isBackCountertop = !isBathroom && CONTEXT_MENU_KITCHEN_COUNTERTOPS.includes(partId);
  let existingWizardItem = null;

  if (isVanity && (getCurrentRoomType(layout) === LOOK_ROOM_TYPES.as)) {
    returnObject.showButtons = returnObject.allButtons.filter(button => {
      return !CONTEXT_MENU_VANITY_ONLY.includes(button.partId) || CONTEXT_MENU_VANITY_ONLY.includes(button.partId) && button.partId === partId
    });
    if (!returnObject.showButtons.some(testBtn => CONTEXT_MENU_VANITY_ONLY.includes(testBtn.partId))) {
      returnObject.showButtons.push({
        partId: activeVanityType,
        translateId: activeVanityType === "vanity_cabinet" ? "visualizer.bathroom.vanity.vanity" : "visualizer.bathroom.vanity." + activeVanityType,
        hasSubMenu: true,
      });
    }
    if (!IS_QKB_UI) {
      const sinkIndex = returnObject.showButtons.findIndex(button => button.partId === "vanity_sink");
      if (sinkIndex > -1) {
        const sinkParent = layout.getFeatureGroupByPartId("vanity_sink");
        const isPedestal = sinkParent.activeFeature && sinkParent.activeFeature.metaData["MountType"] && sinkParent.activeFeature.metaData["MountType"].includes("ST");
        returnObject.showButtons.splice(isPedestal ? sinkIndex : sinkIndex + 1, 0, {
          partId: "vanity_pedestal_sink",
          translateId: "visualizer.bathroom.vanity.vanity_pedestal_sink",
        });
      }
    }
    const backsplashIndex = returnObject.showButtons.findIndex(button => button.partId === "vanity_backsplash");
    if (backsplashIndex > -1) {
      const backsplashParent = layout.getFeatureGroupByPartId("vanity_backsplash");
      // console.log("backsplashParent", backsplashParent);
      if (backsplashParent && backsplashParent.hideLayerCondition()) {
        returnObject.showButtons.splice(backsplashIndex, 1);
      }
    }

    if (Array.isArray(wizardList) && wizardList.length && (!IS_QKB_UI || wizardIsActive)) {
      existingWizardItem = getExistingWizardForGroups(
        returnObject.showButtons.map(btn => btn.partId),
        wizardList,
        activePreset
      );
      if (existingWizardItem) {
        const vanityButtonIndex = returnObject.showButtons.findIndex(button => CONTEXT_MENU_VANITY_BUTTONS.includes(button.partId));
        if (vanityButtonIndex > -1) {
          const vanityWizardButton = {
            partId: "vanity_wizard-" + existingWizardItem.id,
            translateId: activeVanityType === "vanity_cabinet" ? "visualizer.bathroom.vanity.vanity" : "visualizer.bathroom.vanity." + activeVanityType,
            isWizard: true,
            wizardId: existingWizardItem.id,
          };
          fabricatorState.isAmericanStandard
            ? returnObject.showButtons.splice(vanityButtonIndex, 1, vanityWizardButton)
            : returnObject.showButtons.unshift(vanityWizardButton)
        }
        if (fabricatorState.isAmericanStandard) {
          returnObject.showButtons = returnObject.showButtons.filter(button => !button.partId.includes("sink")) //LX-791
        }
      }
    }

  } else if (isShower && Array.isArray(wizardList) && wizardList.length) {
    existingWizardItem = getExistingWizardForGroups([...CONTEXT_MENU_SHOWER_ALL, ...CONTEXT_MENU_SHOWER_OTHER], wizardList, activePreset);
    if (existingWizardItem) {
      const showerWizardButton = {
        partId: "shower_wizard-" + existingWizardItem.id,
        translateId: "visualizer.bathroom.shower.shower",
        isWizard: true,
        wizardId: existingWizardItem.id,
      };
      if (fabricatorState.isLixil) {
        returnObject.showButtons = [showerWizardButton]
      } else {
        returnObject.showButtons.push(showerWizardButton)
      }
    }
  } else if (isCenterIsland && Array.isArray(wizardList) && wizardList.length) {
    existingWizardItem = getExistingWizardForGroups(CONTEXT_MENU_KITCHEN_CENTER_ISLAND, wizardList, activePreset);
    if (existingWizardItem) {
      const countertopWizardButton = {
        partId: "countertop_wizard-" + existingWizardItem.id,
        translateId: "wizard.contextMenu.wizardBuild",
        isWizard: true,
        wizardId: existingWizardItem.id,
      };
      returnObject.showButtons.push(countertopWizardButton)
    }
  } else if (isBackCountertop && Array.isArray(wizardList) && wizardList.length) {
    existingWizardItem = getExistingWizardForGroups(CONTEXT_MENU_KITCHEN_COUNTERTOPS, wizardList, activePreset);
    if (existingWizardItem) {
      const countertopWizardButton = {
        partId: "countertop_wizard-" + existingWizardItem.id,
        translateId: "wizard.contextMenu.wizardBuild",
        isWizard: true,
        wizardId: existingWizardItem.id,
      };
      returnObject.showButtons.push(countertopWizardButton)
    }
  }

  if (isBathroom && isShower && IS_QKB_UI && CONTEXT_MENU_SHOWER_ACCESSORIES.some(accPartId => {
    const accFg = layout.getFeatureGroupByPartId(accPartId);
    return accFg && layout.hasNavItemsLength({part: accFg})
  })) {
    const accessoriesButton = {
      partId: "accessories",
      translateId: "visualizer.bathroom.accessories",
      hasSubMenu: true,
    };
    returnObject.showButtons.push(accessoriesButton);
  }

  if (IS_QKB_UI && document.kvConfig.visualizerOnly) {
    // remove wizard, as we can't jump to the quotingtool
    returnObject.showButtons = returnObject.showButtons.filter(button => !button.isWizard)
  } else if (existingWizardItem && existingWizardItem.hideContext) {
    returnObject.showButtons = returnObject.showButtons.filter(button => button.isWizard) // wizard only
  }

  return returnObject;
};

export const getOptionStyles = (filterValue) => { // we have the logic with additionalImages in the FeatureWizardBody component
  let styles = {};
  let thumbnail = (Array.isArray(filterValue.additionalImages) && filterValue.additionalImages.length)
    ? filterValue.additionalImages[0].imageUrl
    : s3FilterImagePath(filterValue.icon);
  if (thumbnail) {
    styles.backgroundImage = "url(" + thumbnail + ")";
  }
  if (!thumbnail) {
    styles.backgroundColor =
      filterValue.value && filterValue.value.includes("BLACK")
        ? "black"
        : filterValue.value && filterValue.value.includes("BRONZE")
          ? "#3f270f"
          : filterValue.value && filterValue.value.includes("NICKEL")
            ? "#727472"
            : filterValue.value;
  }
  return styles
};
